import { api } from "../common/http";

const toPage = (res) => res.data;

const BusinessApi = {
  list: async ({
    page = 0,
    size = 20,
    sort = "name,asc",
    q,
    name,
    country,
    enabled,
    statuses,
    createdFrom,
    createdTo,
  } = {}) => {
    const params = { page, size, sort };
    if (q) params.q = q;
    if (name) params.name = name;
    if (country) params.country = country;
    if (enabled !== undefined) params.enabled = enabled;
    if (Array.isArray(statuses) && statuses.length) params.statuses = statuses;
    if (createdFrom) params.createdFrom = createdFrom;
    if (createdTo) params.createdTo = createdTo;

    const res = await api.get("/admin/businesses", { params });
    return toPage(res);
  },

  listPublic: async ({ page = 0, size = 20, sort = "name,asc" } = {}) => {
    const params = { page, size, sort };
    const res = await api.get("/admin/businesses/public", { params });
    return toPage(res);
  },

  getById: async (id) => (await api.get(`/admin/businesses/${id}`)).data,

  getByUuid: async (uuid) => (await api.get(`/admin/businesses/uuid/${uuid}`)).data,

  create: async (data) => (await api.post("/admin/businesses", data)).data,

  update: async (id, data) => (await api.put(`/admin/businesses/${id}`, data)).data,

  remove: async (id) => (await api.delete(`/admin/businesses/${id}`)).data,

  purgeArchived: async ({ retentionDays } = {}) =>
    (await api.post("/admin/businesses/purge-archived", { retentionDays })).data,

  approve: async (id, note) =>
    (await api.post(`/admin/businesses/${id}/approve`, note ? { note } : {})).data,

  reject: async (id, reason) =>
    (await api.post(`/admin/businesses/${id}/reject`, { reason })).data,

  suspend: async (id, reason) =>
    (await api.post(`/admin/businesses/${id}/suspend`, { reason })).data,

  reinstate: async (id, note) =>
    (await api.post(`/admin/businesses/${id}/reinstate`, note ? { note } : {})).data,

  setEnabled: async (id, enabled, note) =>
    (await api.patch(`/admin/businesses/${id}/enabled`, { enabled, note })).data,

  enable: async (id, note) =>
    (await api.patch(`/admin/businesses/${id}/enabled`, { enabled: true, note })).data,

  disable: async (id, note) =>
    (await api.patch(`/admin/businesses/${id}/enabled`, { enabled: false, note })).data,
};

export default BusinessApi;
